export default __webpack_public_path__ + "static/media/kappa-sigma-mu-title.0283b668.svg";